import React from 'react';
import './InstructionModal.css';

const InstructionModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="im-modal-overlay" onClick={onClose}>
            <div className="im-modal" onClick={(e) => e.stopPropagation()}>
                <div className="im-modal-header">
                    <div className="im-modal-header-content">
                        <div className="im-modal-icon">❓</div>
                        <h2 className="im-modal-title">Инструкция по работе с диаграммой Ганта</h2>
                    </div>
                    <button className="im-modal-close" onClick={onClose} aria-label="Закрыть">
                        ×
                    </button>
                </div>

                <div className="im-modal-body">
                    <div className="im-instruction-content">

                        {/* Секция 1: Основы */}
                        <section className="im-section">
                            <h3 className="im-section-title">
                                <span className="im-section-icon">🎯</span>
                                Основные возможности
                            </h3>
                            <div className="im-section-content">
                                <div className="im-feature-grid">
                                    <div className="im-feature-card">
                                        <div className="im-feature-icon">📊</div>
                                        <div className="im-feature-info">
                                            <h4>Два вида отображения</h4>
                                            <p>Переключайтесь между <strong>Диаграммой Ганта</strong> для визуализации временных отрезков и <strong>Таблицей</strong> для детального просмотра данных.</p>
                                        </div>
                                    </div>

                                    <div className="im-feature-card">
                                        <div className="im-feature-icon">🔍</div>
                                        <div className="im-feature-info">
                                            <h4>Умный поиск</h4>
                                            <p>Ищите по названию, номеру заказа, описанию или статусу. Поиск работает во всех типах данных: заказы, операции, ресурсы.</p>
                                        </div>
                                    </div>

                                    <div className="im-feature-card">
                                        <div className="im-feature-icon">🔄</div>
                                        <div className="im-feature-info">
                                            <h4>Два источника данных</h4>
                                            <p>Работайте с <strong>демо-данными</strong> для тестирования или подключитесь к <strong>реальному API</strong> для работы с актуальной информацией.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* Секция 2: Работа с диаграммой */}
                        <section className="im-section">
                            <h3 className="im-section-title">
                                <span className="im-section-icon">📈</span>
                                Работа с диаграммой Ганта
                            </h3>
                            <div className="im-section-content">
                                <div className="im-steps">
                                    <div className="im-step">
                                        <div className="im-step-number">1</div>
                                        <div className="im-step-content">
                                            <h4>Навигация по временной шкале</h4>
                                            <ul>
                                                <li>Используйте <strong>горизонтальную прокрутку</strong> для перемещения по датам</li>
                                                <li><strong>Вертикальная прокрутка</strong> позволяет просматривать все элементы</li>
                                                <li>Красная линия показывает <strong>текущую дату</strong></li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="im-step">
                                        <div className="im-step-number">2</div>
                                        <div className="im-step-content">
                                            <h4>Иерархическое отображение</h4>
                                            <ul>
                                                <li><span className="im-badge im-badge-order">📋 Заказы</span> — верхний уровень иерархии</li>
                                                <li><span className="im-badge im-badge-operation">⚙️ Операции</span> — входят в состав заказов</li>
                                                <li><span className="im-badge im-badge-resource">👤 Ресурсы</span> — назначены на операции</li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="im-step">
                                        <div className="im-step-number">3</div>
                                        <div className="im-step-content">
                                            <h4>Взаимодействие с элементами</h4>
                                            <ul>
                                                <li>Нажмите <strong>кнопку "▶"</strong> чтобы развернуть/свернуть детали</li>
                                                <li><strong>Клик по цветной полоске</strong> открывает детальную информацию</li>
                                                <li><strong>Наведите курсор</strong> на элемент для просмотра подсказки</li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="im-step">
                                        <div className="im-step-number">4</div>
                                        <div className="im-step-content">
                                            <h4>Цветовая индикация статусов</h4>
                                            <div className="im-status-grid">
                                                <div className="im-status-item" style={{ '--status-color': '#10b981' }}>
                                                    <span className="im-status-dot"></span>
                                                    <span>Утверждено / Завершено</span>
                                                </div>
                                                <div className="im-status-item" style={{ '--status-color': '#3b82f6' }}>
                                                    <span className="im-status-dot"></span>
                                                    <span>В работе</span>
                                                </div>
                                                <div className="im-status-item" style={{ '--status-color': '#f59e0b' }}>
                                                    <span className="im-status-dot"></span>
                                                    <span>Забронировано</span>
                                                </div>
                                                <div className="im-status-item" style={{ '--status-color': '#ef4444' }}>
                                                    <span className="im-status-dot"></span>
                                                    <span>Отменено</span>
                                                </div>
                                                <div className="im-status-item" style={{ '--status-color': '#eab308' }}>
                                                    <span className="im-status-dot"></span>
                                                    <span>Готов к выполнению</span>
                                                </div>
                                                <div className="im-status-item" style={{ '--status-color': '#8b5cf6' }}>
                                                    <span className="im-status-dot"></span>
                                                    <span>На рассмотрении</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* Секция 3: Работа с таблицей */}
                        <section className="im-section">
                            <h3 className="im-section-title">
                                <span className="im-section-icon">📋</span>
                                Табличное представление
                            </h3>
                            <div className="im-section-content">
                                <div className="im-tips">
                                    <div className="im-tip">
                                        <div className="im-tip-icon">🔍</div>
                                        <div className="im-tip-content">
                                            <h4>Фильтрация и сортировка</h4>
                                            <p>Используйте заголовки столбцов для сортировки данных. Фильтруйте информацию по статусу, датам или типу элемента.</p>
                                        </div>
                                    </div>

                                    <div className="im-tip">
                                        <div className="im-tip-icon">📱</div>
                                        <div className="im-tip-content">
                                            <h4>Адаптивный дизайн</h4>
                                            <p>Интерфейс автоматически подстраивается под размер экрана. На мобильных устройствах доступны компактные режимы отображения.</p>
                                        </div>
                                    </div>

                                    <div className="im-tip">
                                        <div className="im-tip-icon">💾</div>
                                        <div className="im-tip-content">
                                            <h4>Экспорт данных</h4>
                                            <p>В табличном режиме доступен экспорт данных в форматах CSV и Excel для дальнейшего анализа.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* Секция 4: Быстрые клавиши */}
                        <section className="im-section">
                            <h3 className="im-section-title">
                                <span className="im-section-icon">⌨️</span>
                                Быстрые клавиши
                            </h3>
                            <div className="im-section-content">
                                <div className="im-shortcuts">
                                    <div className="im-shortcut">
                                        <kbd>Ctrl</kbd> + <kbd>F</kbd>
                                        <span>Быстрый поиск</span>
                                    </div>
                                    <div className="im-shortcut">
                                        <kbd>Esc</kbd>
                                        <span>Закрыть модальное окно / сбросить поиск</span>
                                    </div>
                                    <div className="im-shortcut">
                                        <kbd>Tab</kbd>
                                        <span>Переключение между элементами управления</span>
                                    </div>
                                    <div className="im-shortcut">
                                        <kbd>←</kbd> <kbd>→</kbd>
                                        <span>Навигация по временной шкале</span>
                                    </div>
                                    <div className="im-shortcut">
                                        <kbd>↑</kbd> <kbd>↓</kbd>
                                        <span>Навигация по строкам</span>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* Секция 5: Поддержка */}
                        <section className="im-section">
                            <h3 className="im-section-title">
                                <span className="im-section-icon">❓</span>
                                Нужна помощь?
                            </h3>
                            <div className="im-section-content">
                                <div className="im-support">
                                    <p>Если у вас возникли вопросы или проблемы:</p>
                                    <div className="im-contact-info">
                                        <div className="im-contact-item">
                                            <span className="im-contact-icon">📧</span>
                                            <span>support@monitor.ru</span>
                                        </div>
                                        <div className="im-contact-item">
                                            <span className="im-contact-icon">📞</span>
                                            <span>+7 (999) 123-45-67</span>
                                        </div>
                                        <div className="im-contact-item">
                                            <span className="im-contact-icon">🕒</span>
                                            <span>Пн-Пт: 9:00-18:00</span>
                                        </div>
                                    </div>
                                    <div className="im-version">
                                        <span className="im-version-label">Версия системы:</span>
                                        <span className="im-version-value">2.1.4</span>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>

                <div className="im-modal-footer">
                    <button className="im-modal-close-btn" onClick={onClose}>
                        Понятно, закрыть
                    </button>
                    <div className="im-footer-hint">
                        <span className="im-hint-icon">💡</span>
                        Эта инструкция доступна в любой момент по кнопке "?"
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InstructionModal;